<template lang="pug">
div
  b-field(
    :type="message ? 'is-danger' : ''"
    :message="message"
    expanded
  )
    b-input(
      :loading="settings.loading"
      :value="value.video_link"
      @input="set($event, '_embedded.video.video_link')"
      @change.native="change($event)"
    )
  div(v-if="imported.title")
    .media
      figure.media-left
        img(:src="imported.artwork" width="160")
      .media-content
        .content
          p
            span {{ imported.title }}
            br
            small.has-text-grey {{ imported.long_desc | truncate(150) }}
</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
import axios from 'axios';
import * as getters from '@/store/types/getters';
import * as mutations from '@/store/types/mutations';

export default {
  name: 'video-field',
  computed: {
    ...mapGetters({
      episode: getters.GET_EPISODE,
    }),
    service() {
      const link = this.value.video_link;
      if (link) {
        if (link.match(/youtube.com|youtu.be/i)) {
          return 'youtube';
        } else if (link.match(/vimeo.com/i)) {
          return 'vimeo';
        }
        return null;
      }
      return null;
    },
  },
  created() {
    if (this.value.video_link) {
      this.lookup(this.value.video_link, false);
    }
  },
  data() {
    return {
      link: null,
      imported: {},
      message: null,
      settings: {
        loading: false,
      },
    };
  },
  methods: {
    change(event) {
      this.reset();
      const val = event.target.value;
      if (val) {
        this.lookup(val, true);
      }
    },
    error() {
      this.isLoading = false;
      this.$dialog.alert({
        title: 'Oops...',
        message: `Invalid ${this.service} id`,
        type: 'is-danger',
        hasIcon: true,
      });
    },
    lookup(val, update) {
      this.message = null;
      switch (this.service) {
        case 'youtube':
          this.lookupYoutube(val, update);
          break;
        case 'vimeo':
          this.lookupVimeo(val, update);
          break;
        default:
          if (val) {
            this.message = 'Not a vaild YouTube or Vimeo link';
          }
          break;
      }
    },
    async lookupYoutube(val, update) {
      const params = new URL(val).searchParams;
      const id = params.get('v');
      if (id) {
        const endpoint = 'https://www.googleapis.com/youtube/v3/videos';
        const { data } = await axios.get(endpoint, {
          params: {
            key: process.env.GOOGLE_API_KEY,
            id,
            part: 'snippet',
          },
        });
        if (data.pageInfo.totalResults > 0) {
          const snippet = data.items[0].snippet;
          this.imported = {
            title: snippet.title,
            long_desc: snippet.description,
            artwork: snippet.thumbnails.high.url,
            pub_date: moment(snippet.publishedAt).toDate(),
            is_published: true,
            video_link: val,
            video_id: id,
            service: 'youtube',
          };
          if (update) {
            this.setEpisodeFromImport();
          }
        } else {
          this.message = 'Invalid YouTube link';
        }
      }
    },
    async lookupVimeo(val, update) {
      const url = new URL(val);
      const id = url.pathname.replace(/\//, '');
      if (id) {
        const endpoint = `https://api.vimeo.com/videos/${id}`;
        const { data } = await axios.get(endpoint, {
          headers: {
            Authorization: `Bearer ${process.env.VIMEO_ACCESS_TOKEN}`,
          },
        });
        this.imported = {
          title: data.name,
          long_desc: data.description,
          artwork: data.pictures.sizes[0].link,
          pub_date: moment(data.release_time).toDate(),
          is_published: true,
          video_id: id,
          video_link: val,
          service: 'vimeo',
        };
        if (update) {
          this.setEpisodeFromImport();
        }
      }
    },
    reset() {
      this.imported = {};
    },
    set(val, key) {
      this.$store.commit(mutations.SET_EPISODE_FIELD, {
        key,
        val,
      });
    },
    setEpisodeFromImport() {
      const keys = [
        'title',
        'long_desc',
        'pub_date',
        'is_published',
      ];
      keys.forEach((key) => {
        this.$store.commit(mutations.SET_EPISODE_FIELD, {
          key,
          val: this.imported[key],
        });
      });
      const videoKeys = [
        'video_id',
        'video_link',
        'service',
      ];
      videoKeys.forEach((key) => {
        this.$store.commit(mutations.SET_EPISODE_FIELD, {
          key: `_embedded.video.${key}`,
          val: this.imported[key],
        });
      });
      this.$store.commit(mutations.SET_EPISODE_FIELD, {
        key: '_embedded.video.id',
        val: null,
      });
    },
  },
  props: {
    value: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  watch: {
    'episode.id': 'reset',
  },
};
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/form/VideoField.vue